import { useListStore } from "@/stores/lists/lists";

export function getListValueByName(listVal, value) {
    const listStore = useListStore();
    const list = listStore.lists[listVal];

    if (!list) {
        return value;
    }
    const listValue = list.find(item => item.value === value);

    if (!listValue) {
        return "Unknown";
    }

    return listValue?.name || value;
}
